import axios from "axios"
import { URL_SEARCH_BY_NAME, URL_GET_ALL_VIDEOGAME, URL_GET_ALL_GENRES, URL_GET_DETAIL_VIDEOGAME } from "../utils/urls"

export function getVideogames(){
    return async function(dispatch){
        dispatch(beforeCallApi())
        let response = await axios(URL_GET_ALL_VIDEOGAME)
        dispatch(callApi(response.data))

    }
}
const beforeCallApi = () => ({
    type: "BEFORE_CALL_API"
});
const callApi =(data) => ({
    type: "GET_VIDEOGAMES",
    payload: data
});

export function getGenres(){
    return async function(dispatch){
        let response = await axios(URL_GET_ALL_GENRES)
        return dispatch({
            type: "GET_GENRES",
            payload: response.data
        })
    }
}

export function filterByGenre(payload){
    return {
        type: "FILTER_BY_GENRE",
        payload
    }
}

export function filterByName(payload){
    return {
        type: "FILTER_BY_NAME",
        payload
    }
}

export function filterByCreated(payload){
    return {
        type: "FILTER_BY_CREATED",
        payload
    }
}

export function searchByName(input){
    return async function(dispatch){
        dispatch(beforeCallApi())
        try {
            let response = await axios(URL_SEARCH_BY_NAME+input)
            dispatch(search(response.data))
        } catch (error) {
            //console.log(error.response.data)
            dispatch(errorApi())
        }

    }
}

const search = (data) => ({
    type: "SEARCH_BY_NAME",
    payload: data
});

const errorApi = () => ({
    type: "ERROR_API"
})

export function getVideogameDetail(id){
    return async function(dispatch){
        dispatch(beforeCallApi())
        try {
            let response = await axios(URL_GET_DETAIL_VIDEOGAME+id)
            dispatch(videogameDetail(response.data))
        } catch (error) {
            dispatch(errorApi())
        }

    }
}

const videogameDetail = (data) => ({
    type: "VIDEOGAME_DETAIL",
    payload: data
})